
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import {
  ServicePageHero,
  ServiceProcess,
  ServiceTrust,
  ServiceContact,
} from '../../../components/feature';
import { FLOOD_CLEANUP_DATA, SERVICE_FORM_ENDPOINT } from '../../../data/servicePageData';

export default function FloodCleanupPage() {
  const { title, subtitle, heroImage, processTitle, processSubtitle, steps } = FLOOD_CLEANUP_DATA;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServicePageHero title={title} subtitle={subtitle} backgroundImage={heroImage} />
      <ServiceProcess title={processTitle} subtitle={processSubtitle} steps={steps} />
      <ServiceTrust serviceName="Flood Cleanup" />
      <ServiceContact serviceName="Flood Cleanup" formEndpoint={SERVICE_FORM_ENDPOINT} />
      <Footer />
    </div>
  );
}
